export default "__VITE_ASSET__Bwib5e$Z__"